<template>
  <div>
    <v-form ref="accountForm" class="multi-col-validation custom-form" @submit.prevent="add">
      <v-row>
        <v-col cols="6" class="input-padding">
          <label class="text--primary text-xs2 required-mark">{{ 'Task Name' }}</label>
          <v-text-field
            v-model="modalFormData.name"
            outlined
            name="name"
            dense
            :rules="[required]"
            placeholder="Task Name"
          ></v-text-field>
        </v-col>

        <v-col cols="6" class="input-padding">
          <label class="text--primary text-xs2">{{ 'Assignee' }}</label>
          <v-autocomplete
            v-model="modalFormData.assignee_id"
            :items="userOptions"
            data-cy="assignee"
            outlined
            dense
            multiple
            autocomplete="null"
            class="custom-input"
            placeholder="Assignee"
            :search-input.sync="assigneeSearch"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="6" class="input-padding">
          <label class="text--primary text-xs2">{{ 'Start & End Date' }}</label>
          <DateRangePicker
            label="Date Range"
            :start-date="modalFormData['from_date']"
            :end-date="modalFormData['to_date']"
            @onSelect="
              ;(modalFormData['from_date'] = $event[0]), (modalFormData['to_date'] = $event[1])
            "
          />
        </v-col>
        <v-col cols="6" class="input-padding">
          <label class="text--primary text-xs2">{{ 'Due Date' }}</label>
          <date-picker
            label="Due Date"
            :date="modalFormData['due_date']"
            @onSelect="modalFormData['due_date'] = $event"
          ></date-picker>
        </v-col>
        <v-col cols="6" class="input-padding">
          <label class="text--primary text-xs2 required-mark">{{ 'Work Flow' }}</label>
          <v-autocomplete
            v-model="modalFormData.workflow_id"
            :items="workflowOptions"
            :rules="[required]"
            outlined
            :readonly="readAble"
            class="custom-input"
            dense
            placeholder="Work Flow"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="6" class="input-padding">
          <label class="text--primary text-xs2 required-mark">{{ 'Workflow Status' }}</label>
          <v-autocomplete
            v-model="modalFormData.workflow_status_id"
            :items="workflowStatusOptions"
            :rules="[required]"
            outlined
            class="custom-input"
            dense
            placeholder="Workflow Status"
            @focus="loadWorkflowStatus"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="6" class="input-padding">
          <label class="text--primary text-xs2">{{ 'Contact' }}</label>
          <autocomplete-view
            v-if="isVisibleContactName"
            :label="defaultContactName"
            @handleClose="isVisibleContactName = false"
          />

          <v-autocomplete
            v-else
            v-model="modalFormData.contact_id"
            :items="contactArray"
            :search-input.sync="contactSearch"
            outlined
            dense
            autocomplete="null"
            item-text="name"
            item-value="uuid"
            class="custom-input"
            placeholder="Search Contacts..."
            @update:search-input="processContactInput"
          >
            <template v-slot:item="data">
              <v-list-item-title class="text-xs3">
                <div>{{ data.item.name }}</div>
                <div v-if="data.item.related_to" class="text-xs">
                  {{ data.item.related_to.name }}
                </div>
              </v-list-item-title>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="6" class="input-padding">
          <label class="text--primary text-xs2 required-mark">{{ 'Related To' }}</label>
          <autocomplete-view
            v-if="isVisibleName"
            :label="defaultPropName"
            @handleClose="isVisibleName = false"
          />
          <v-autocomplete
            v-else
            v-model="modalFormData.prop_id"
            :items="relatedToList"
            :search-input.sync="relatedToSearch"
            outlined
            dense
            :rules="[required]"
            autocomplete="null"
            item-text="name"
            item-value="uuid"
            class="custom-input"
            placeholder="Search..."
            @update:search-input="processInput"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" class="input-padding">
          <label class="text--primary text-xs2">{{ 'Desription' }}</label>
          <v-textarea
            v-model="modalFormData.details"
            outlined
            name="desription"
            dense
            rows="3"
            placeholder="Desription"
          ></v-textarea>
        </v-col>
      </v-row>

      <div class="mt-4 text-right">
        <v-btn color="primary" data-cy="crm-task-create" small :loading="loading" type="submit">
          Create
        </v-btn>
      </div>
    </v-form>
  </div>
</template>
<script>
import { ref, watch } from '@vue/composition-api'
import { storeActions } from '@/store/storeConstants'
import store from '@/store'
import { required } from '@core/utils/validation'
import Toaster from '@core/utils/sweetToast'
import { ERROR_RESPONSE } from '@/constants/appConstants'
import DatePicker from '@/components/shared-components/DatePicker.vue'
import DateRangePicker from '@/components/shared-components/DateRangePicker.vue'
import useDebounce from '@/plugins/useDebounce'
import AutocompleteView from '@/components/shared-components/AutocompleteView.vue'

export default {
  components: { DatePicker, DateRangePicker, AutocompleteView },
  props: {
    propType: {
      type: String,
      required: true,
    },
    propId: {
      type: String,
      default: undefined,
    },
    readAble: {
      type: Boolean,
      default: false,
    },
    contactId: {
      type: String,
      default: undefined,
    },
    defaultContactName: {
      type: String,
      default: undefined,
    },
    defaultPropName: {
      type: String,
      default: undefined,
    },
    moduleId: {
      type: String,
      default: null,
    },
    module: {
      type: String,
      required: true,
    },
    contactArray: {
      type: Array,
      default: () => [],
    },
    relatedToList: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const modalFormData = ref({
      type: 'task',
      name: null,
      from_date: null,
      to_date: null,
      due_date: null,
      workflow_id: null,
      workflow_status_id: null,
      contact_id: null,
      assignee_id: [],
    })
    const userOptions = ref([])
    const accountForm = ref(null)
    const loading = ref(false)

    const isVisibleName = ref(false)
    const isVisibleContactName = ref(false)
    const workflowOptions = ref([])
    const workflowStatusOptions = ref([])
    const { debounce } = useDebounce()
    const contactSearch = ref(null)
    const relatedToSearch = ref(null)
    const assigneeSearch = ref(null)

    const getWorkflowList = () => {
      const payLoad = {
        component: 'setup/taskManagement/workflow/list',
        object: {
          type: 'module',
          module: props.propType,
        },
      }
      store.dispatch(`common/${storeActions.CREATE}`, payLoad).then(({ data }) => {
        if (data.success) {
          workflowOptions.value = data.data.map(opt => {
            return {
              value: opt.uuid,
              text: opt.name,
            }
          })
          if (workflowOptions.value.length) {
            modalFormData.value.workflow_id = workflowOptions.value[0].value
          }
        }
      })
    }

    getWorkflowList()

    const loadWorkflowStatus = () => {
      if (workflowStatusOptions.value.length) return
      const config = {
        component: `setup/taskManagement/workflow/${modalFormData.value.workflow_id}/status`,
      }
      store.dispatch(`common/${storeActions.GET_ALL_RECORDS}`, config).then(({ data }) => {
        if (data.success) {
          workflowStatusOptions.value = data.data.map(opt => {
            return {
              value: opt.uuid,
              text: opt.name,
            }
          })
        }
      })
    }

    const getuserList = () => {
      const payLoad = {
        component: 'security/users',
        filter: {
          limit: -1,
        },
      }
      store.dispatch(`common/${storeActions.GET_ALL_RECORDS}`, payLoad).then(({ data }) => {
        if (data.success) {
          userOptions.value = data.data.map(opt => {
            return {
              value: opt.uuid,
              text: `${opt.firstname} ${opt.lastname}`,
            }
          })
        }
      })
    }

    const updateAssignee = async (taskId, formValue) => {
      if (!formValue?.assignee_id?.length) return
      const payLoad = {
        component: `task-management/spaces/item/assign/${taskId}`,
        object: {
          assignee_ids: formValue.assignee_id,
        },
      }
      await store.dispatch(`common/${storeActions.CREATE}`, payLoad)
    }

    const add = () => {
      const isValid = accountForm.value.validate()
      if (!isValid) return
      loading.value = true
      const payLoad = {
        object: {
          prop_id: props.propId,
          contact_id: props.contactId,
          ...modalFormData.value,
          prop_type: props.propType,
          module: props.module,
          module_id: props.moduleId,
        },
        component: 'task-management/spaces/item',
      }
      store
        .dispatch(`common/${storeActions.CREATE}`, payLoad)
        .then(async ({ data }) => {
          if (data.success) {
            await updateAssignee(data.data.uuid, { ...modalFormData.value })
            modalFormData.value = {
              ...modalFormData.value,
              name: null,
              from_date: null,
              due_date: null,
              to_date: null,
              details: null,
              assignee_id: [],
            }
            accountForm.value.resetValidation()
            emit('fetchData')
            Toaster.success(data.message)
          } else {
            Toaster.error(data.message, 'warning')
          }
          loading.value = false
        })
        .catch(err => {
          loading.value = false
          Toaster.error(err?.response?.data?.message ?? ERROR_RESPONSE)
        })
    }

    const processContactInput = () => {
      // emit event and fetch contact
      debounce(() => emit('fetchContacts', contactSearch.value), 800)
    }

    const processInput = () => {
      // emit event and fetch contact
      debounce(() => emit('fetchRelatedTo', relatedToSearch.value), 500)
    }

    getuserList()

    watch(
      () => props.defaultPropName,
      val => {
        if (val) {
          isVisibleName.value = true
        }
      },
      { immediate: true },
    )

    watch(
      () => props.defaultContactName,
      val => {
        if (val) {
          isVisibleContactName.value = true
        }
      },
      { immediate: true },
    )
    watch(() => modalFormData.value.assignee_id, () => {
      assigneeSearch.value = null
    })

    return {
      accountForm,
      add,
      loading,
      processContactInput,
      processInput,
      contactSearch,
      isVisibleContactName,
      relatedToSearch,
      isVisibleName,
      loadWorkflowStatus,
      workflowStatusOptions,
      userOptions,
      workflowOptions,
      modalFormData,
      assigneeSearch,
      required,
    }
  },
}
</script>
